export default __webpack_public_path__ + "static/media/tt.39bd2afe.jpg";